import router from "./router"
import store from "./store"
import {Message} from "element-ui"
import NProgress from "nprogress"
import "nprogress/nprogress.css"
import {getToken, removeToken} from "@/utils/auth" // get token from cookie
import getPageTitle from "@/utils/get-page-title"
import Cookies from "js-cookie"
NProgress.configure({showSpinner: false})
// const whiteList = ["/login", "/auth-redirect"] // no redirect whitelist

const whiteList = [
	"/tourist",
	"/bingdingPhone",
	"/register",
	"/notices",
	"/us",
	"/privacy",
	"/recruitment",
	"/fordetails/goods-details",
	"/login",
	"/wxcallback",
	"/helper",
	"/forgetPassword",
	'/contact'

]

router.beforeEach(async (to, from, next) => {
	NProgress.start()
	document.title = getPageTitle(to.meta.title)
	// console.log(to, from)
	const hasToken = getToken()
	if (hasToken) {
		if (to.path === "/login") {
			// next({path: "/"})

			next({name: "dashboard"})
			NProgress.done()
		} else {
			// store.dispatch("merchant/getCartNum")
			next()
			// const hasRoles = store.getters.roles && store.getters.roles.length > 0
			// if (hasRoles) {
			// 	next()
			// } else {
			// 	try {
			// 		const {roles} = await store.dispatch("user/getInfo")
			// 		next({...to, replace: true})
			// 	} catch (error) {
			// 		// remove token and go to login page to re-login
			// 		await store.dispatch("user/resetToken")
			// 		Message.error(error || "发生错误了")
			// 		next(`/login?redirect=${to.path}`)
			// 		NProgress.done()
			// 	}
			// }
		}
	} else {
		if (whiteList.indexOf(to.path) !== -1) {
			next()
		} else {
			next()
			// next("/tourist")
			NProgress.done()
		}
		// if (to.path == "/tourist" || to.path == "/register") next();
		// else {
		//   next("/tourist");
		//   NProgress.done();
		// }
	}
	// next({ path: "/" })
	// next({ path:"/tourist", replace: true });
	// if (hasToken) {
	//   if (to.path === "/login") {
	//     next({ path: "/" });
	//     NProgress.done();
	//   } else {
	//     next();
	//   }
	// } else {
	//   console.log(to)
	//   console.log(from)
	//   console.log("---------------")
	//   next(`/tourist`);

	// }
	// if (hasToken) {
	//   if (to.path === "/login") {
	//     next({ path: "/" });
	//     NProgress.done();
	//   } else {
	//     const hasRoles = store.getters.roles && store.getters.roles.length > 0;

	//     if (hasRoles) {
	//       next();
	//     } else {
	//       try {

	//         // const { roles } = await store.dispatch("user/getInfo");
	//         // const accessRoutes = await store.dispatch(
	//         //   "permission/generateRoutes",
	//         //   roles
	//         // );

	//         const accessRoutes=await store.dispatch("user/getInfo");
	//         console.log("accessRoutes")
	//         console.log(accessRoutes)
	//         await store.dispatch("permission/generateRoutes",accessRoutes);
	//         // router.addRoutes(accessRoutes);
	//         next({ ...to, replace: true });
	//       } catch (error) {
	//         await store.dispatch("user/resetToken");//报错时会将token置空，切记切记
	//         Message.error(error || "Has Error");
	//         next(`/login?redirect=${to.path}`);
	//         NProgress.done();
	//       }
	//     }

	//   }
	// } else {
	//   if (whiteList.indexOf(to.path) !== -1) {
	//     next();
	//   } else {
	//     next(`/login?redirect=${to.path}`);
	//     NProgress.done();
	//   }
	// }
})
router.afterEach(() => {
	NProgress.done()
})
